import { HttpInterceptorFn } from '@angular/common/http';


export const headerInterceptor: HttpInterceptorFn = (req, next) => {

  if (req.method === 'POST' || req.method === 'PUT' || req.method === 'PATCH') {
    req = req.clone({
      setHeaders: {
        'Idempotency-Key': crypto.randomUUID()
      }
    });
  }

  return next(req);
};